import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus, Minus } from "@phosphor-icons/react";
import { FAQS } from "../lib/legalContent";

export default function FAQSection() {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage === "de" ? "de" : i18n.resolvedLanguage === "fr" ? "fr" : "it";
  const items = FAQS[lang];
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-b border-white/10 bg-[#050505]">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold">FAQ</div>
        <h2 className="font-display text-4xl sm:text-5xl uppercase font-black text-white mt-3 tracking-tight">
          {t("faq.title")}
        </h2>
        <p className="mt-4 text-zinc-400 max-w-2xl">{t("faq.subtitle")}</p>

        <div className="mt-12 divide-y divide-white/10 border border-white/10 bg-[#0A0A0A]" data-testid="faq-list">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-4 text-left px-6 py-5 hover:bg-white/[0.02] transition-colors"
                  data-testid={`faq-question-${i}`}
                >
                  <span className="font-display text-lg sm:text-xl uppercase font-bold text-white tracking-tight">{item.q}</span>
                  <span className={`shrink-0 mt-1 transition-transform ${isOpen ? "text-[#E30613]" : "text-zinc-500"}`}>
                    {isOpen ? <Minus size={20} weight="bold" /> : <Plus size={20} weight="bold" />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 text-sm text-zinc-300 leading-relaxed max-w-3xl" data-testid={`faq-answer-${i}`}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
